import(/* webpackMode: "eager" */ "/app/src/app/tools/column-splitter/page.tsx");
